import * as React from 'react';

import { LinkButton } from '@cian/ui-kit';
import { trackMapUrlClick } from '../../containers/ListingsLinks/tracking';
import { StickyBottomLayout } from '../StickyBottomLayout';

interface IMapEntryProps {
  listingUrl: string;
  isShown: boolean;
}

export const ListingEntry: React.FC<IMapEntryProps> = ({ listingUrl, isShown }) => {
  return (
    <StickyBottomLayout isShown={isShown}>
      <LinkButton
        data-testid="ListingEntry"
        href={listingUrl}
        theme="fill_primary"
        target="_blank"
        size="L"
        fullWidth
        onClick={trackMapUrlClick}
      >
        Смотреть ЖК с акциями
      </LinkButton>
    </StickyBottomLayout>
  );
};
